export enum Language {
  english = 'en_US',
  french = 'fr_FR'
}

export const allLanguages: Language[] = Object.values(Language);
